import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { superadminLogin } from "@/services/superadminApi";
import Logo from "@/components/ui/Logo";

export default function SuperAdminLogin() {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        try {
            await superadminLogin(email, password);
            navigate("/superadmin");
        } catch (err) {
            setError(
                err.response?.data?.detail ||
                err.message ||
                "Error al iniciar sesión. Verifica las credenciales."
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={styles.container} className="page-fade-in">
            <div style={styles.card} className="glass-effect">
                {/* Logo / Header */}
                <div style={styles.header}>
                    <div style={styles.logoWrapper}>
                        <Logo size={32} />
                    </div>
                    <h1 style={styles.title}>Super Admin</h1>
                    <p style={styles.subtitle}>Panel de control Conexo POS</p>
                </div>

                {/* Form */}
                <form onSubmit={handleSubmit} style={styles.form}>
                    <div style={styles.field}>
                        <label style={styles.label} htmlFor="sa-email">Correo electrónico</label>
                        <input
                            id="sa-email"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            autoComplete="username"
                            placeholder="admin@conexopos.com"
                            style={styles.input}
                        />
                    </div>
                    <div style={styles.field}>
                        <label style={styles.label} htmlFor="sa-password">Contraseña</label>
                        <input
                            id="sa-password"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            autoComplete="current-password"
                            placeholder="••••••••"
                            style={styles.input}
                        />
                    </div>

                    {error && (
                        <div style={styles.errorBox}>
                            <span style={styles.errorIcon}>⚠️</span> {error}
                        </div>
                    )}

                    <button
                        id="sa-login-btn"
                        type="submit"
                        disabled={loading}
                        className="btn-premium"
                        style={{ padding: '12px', fontSize: '1rem', width: '100%', marginTop: '0.5rem' }}
                    >
                        {loading ? "Verificando…" : "Entrar al panel"}
                    </button>
                </form>

                <p style={styles.back}>
                    <a href="/" style={styles.backLink}>← Volver al sitio</a>
                </p>
            </div>
        </div>
    );
}

const styles = {
    container: {
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "radial-gradient(circle at top, #1E293B, #020617)",
        fontFamily: "var(--font-main, 'Inter', sans-serif)",
        padding: "1rem",
    },
    card: {
        background: "rgba(30,41,59,0.55)",
        padding: "3rem",
        width: "100%",
        maxWidth: "440px",
    },
    header: { textAlign: "center", marginBottom: "2.5rem" },
    logoWrapper: { marginBottom: "1.5rem", display: "flex", justifyContent: "center" },
    title: { color: "#fff", fontSize: "1.75rem", fontWeight: "800", margin: 0, letterSpacing: "-0.02em" },
    subtitle: { color: "var(--text-soft)", fontSize: "0.95rem", marginTop: "0.5rem" },
    form: { display: "flex", flexDirection: "column", gap: "1.5rem" },
    field: { display: "flex", flexDirection: "column", gap: "0.5rem" },
    label: { color: "var(--text-main)", fontSize: "0.875rem", fontWeight: "600" },
    input: {
        padding: "0.875rem 1rem",
        borderRadius: "0.75rem",
        border: "1px solid var(--border-soft)",
        background: "rgba(15,23,42,0.3)",
        color: "#fff",
        fontSize: "1rem",
        outline: "none",
        transition: "border-color 0.2s",
    },
    errorBox: {
        background: "rgba(239,68,68,0.1)",
        border: "1px solid rgba(239,68,68,0.3)",
        borderRadius: "0.75rem",
        padding: "1rem",
        color: "#fca5a5",
        fontSize: "0.875rem",
        display: "flex",
        alignItems: "center",
        gap: "0.5rem"
    },
    back: { textAlign: "center", marginTop: "2rem", marginBottom: 0 },
    backLink: { color: "var(--text-soft)", fontSize: "0.875rem", textDecoration: "none", fontWeight: "500" },
};
